<script lang="ts">
	import MarketMarginRow from '$lib/home/scwallet/homeportfolio/MarketMarginRow.svelte';
	import WithdrawAllUnusedMargins from '$lib/home/scwallet/utils/WithdrawAllUnusedMargins.svelte';

	import {
		firstLoadedMargin,
		sumOfAllUserMargin,
		userMarginList
	} from '$lib/home/userInteract/store';
	import type { MarketIdentifiers } from '$lib/types/market';
	import type { UserMargin } from '$lib/types/user';
	import { addDollarSign, getNumBackInUnits, sortMarginsInDescending } from '$lib/util/util';

	interface UserMarginModified extends UserMargin {
		marketIdentifier: MarketIdentifiers;
	}
	let marginsInDescending: UserMarginModified[];

	$: if ($userMarginList) {
		console.log($userMarginList);
		marginsInDescending = sortMarginsInDescending($userMarginList) as UserMarginModified[];
	}
</script>

<div class="flex flex-col">
	<div class="flex justify-between items-center">
		<p class="text-fx-blue font-semibold text-lg">
			{#if $sumOfAllUserMargin}
				{addDollarSign(getNumBackInUnits($sumOfAllUserMargin, 18, 2))}
			{:else}
				<div>-</div>
			{/if}
		</p>
		<img loading="lazy" src={'new_sc_wallet/markets.svg'} alt="new_sc_wallet/markets.svg" />
	</div>
	<div class="flex justify-between">
		<p class="text-fx-grey-300 text-sm font-regular">Margin Balances</p>
		<WithdrawAllUnusedMargins />
	</div>
</div>

<div class="border-t border-t-fx-grey-600 w-full my-4" />

<div class="flex flex-col gap-2 h-96 overflow-y-auto fx-scrollbar">
	{#if $firstLoadedMargin && marginsInDescending && marginsInDescending.length > 0}
		{#each marginsInDescending as margin}
			<MarketMarginRow
				market={margin.marketIdentifier}
				balance={getNumBackInUnits(margin.depositedMargin, 18, 2)}
			/>
		{/each}
	{:else if $firstLoadedMargin && marginsInDescending && marginsInDescending.length == 0}
		<div class="flex flex-col justify-center items-center h-full">
			<img loading="lazy" src={'no-trades.webp'} alt="static/no-trades.webp" class="w-36" />
			<div class="text-fx-grey-300 text-xs mt-2">No Unused Margins</div>
		</div>
	{:else}
		<div class="flex flex-col items-center w-full h-full justify-between">
			<div
				class="animate-pulse bg-fx-grey-800 h-5 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-5 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-5 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-5 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-5 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-5 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
		</div>
	{/if}
</div>
